export const socialNetworks = {
    EMAIL: {
        name: 'email',
        icon: 'email',
        label: 'Email',
        urlTemplate: 'mailto:?subject=_TEXT_!&body=_TEXT_SHORT_: _URL_'
    },
    FACEBOOK: {
        name: 'facebook',
        icon: 'facebook',
        label: 'Facebook',
        urlTemplate: `https://www.facebook.com/sharer/sharer.php?u=_URL_`
    },
/*    WECHAT: {
        name: 'wechat',
        icon: 'wechat',
        label: 'WeChat',
        urlTemplate: 'weixin://dl/chat?text=_TEXT_ _URL_'
    },*/
    WHATSAPP: {
        name: 'whatsapp',
        icon: 'whatsapp',
        label: 'WhatsApp',
        urlTemplate: 'https://api.whatsapp.com/send?text=_TEXT_ _URL_'
    },
    TELEGRAM: {
        name: 'telegram',
        icon: 'telegram',
        label: 'Telegram',
        urlTemplate: 'https://t.me/share/url?url=_URL_&text=_TEXT_'
    },
    TWITTER: {
        name: 'twitter',
        icon: 'twitterX',
        label: 'X',
        urlTemplate: 'https://twitter.com/intent/tweet?url=_URL_&text_TEXT_',
        style: {
            width: '26px',
            height: '23.5px'
        }
    },
    LINKEDIN: {
        name: 'linkedin',
        icon: 'linkedin',
        label: 'LinkedIn',
        urlTemplate: 'https://www.linkedin.com/shareArticle?mini=true&url=_URL_&title=_TEXT_'
    },
}

export const socialNetworksList = Object.values(socialNetworks)